import { useState } from 'react';
import { Link } from 'react-router';

import ProfileIcon from '~/assets/icons/Profile';
import SoleIcon from '~/assets/icons/Sole';
import Tracked from '~/components/Tracked';
import useEnv from '~/hooks/useEnv';
import useIsSignedIn from '~/hooks/useIsSignedIn';

import MegaNav from '../MegaNav';
import MobileMenu from '../MobileMenu';
import ProfileSignInButton from '../ProfileSignInButton';
import Search from './InternationalHeaderSearch';
import menus from './menus';

export default function InternationalHeader() {
  const env = useEnv();

  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-[49] flex h-[50px] w-full flex-row justify-center bg-black lg:h-[70px]"
      data-site-header
      role="banner"
    >
      <div className="content-width flex w-full justify-center">
        <section className="flex w-full max-w-desktop flex-row items-center gap-8">
          <Link
            to="/"
            className="w-[50px] max-lg:absolute max-lg:left-1/2 max-lg:ml-[-25px] max-lg:mr-8"
          >
            <SoleIcon width="50" height="50" colour="#FFFFFF" />
          </Link>
          {env.FF_INTERNATIONAL_HEADERS && (
            <>
              <div className="flex w-full flex-row justify-between lg:hidden">
                <MobileMenu
                  menu={menus.mobile}
                  mobileMenuIsOpen={mobileMenuIsOpen}
                  setMobileMenuIsOpen={setMobileMenuIsOpen}
                />
              </div>
              <div className="mr-4 flex items-center gap-4 lg:hidden">
                <Search.Mobile />
                <ProfileLink />
              </div>
              <div className="hidden w-full items-center justify-between lg:flex">
                <div>
                  <MegaNav menu={menus.desktop} />
                </div>
                <div className="flex items-center gap-4">
                  <Search.SearchForm />
                  <ProfileLink />
                </div>
              </div>
            </>
          )}
        </section>
      </div>
    </header>
  );
}

function ProfileLink() {
  const isSignedIn = useIsSignedIn();

  if (!isSignedIn) return <ProfileSignInButton />;

  return (
    <Tracked.InternalLink
      pagePosition="Header"
      name="Sign in"
      variant="none"
      to="/profile/"
    >
      <ProfileIcon color="#56BD6F" />
    </Tracked.InternalLink>
  );
}
